export default {
  data() {
    return {
      currentPicture: '',
      visits: 0,
      void: null
    }
  },
  computed: {
    statusStrings() {
      return {
        normal: {
          'DRAFT': this.$pgettext('statuses', 'Waiting for the package'),
          'READYATSTORE': this.$pgettext('statuses', 'Ready at store'),
          'READY': this.$pgettext('statuses', 'Ready to be scheduled'),
          'WAITING': this.$gettextInterpolate(this.$pgettext('statuses', 'Searching for %{courierI18n}'), {courierI18n: this.courierI18n}),
          'PROGRAMMED': this.$pgettext('statuses', 'Route programmed'),
          'CONFIRMED': this.$gettextInterpolate(this.$pgettext('statuses', '%{courierI18n} in transit to origin'), {courierI18n: this.courierI18n}),
          'ATPICKUPPOINT': this.$gettextInterpolate(this.$pgettext('statuses', '%{courierI18n} arrived to origin'), {courierI18n: this.courierI18n}),
          'PICKEDUP': this.$pgettext('statuses', 'Shipping picked up on origin'),
          'INTRANSIT': this.$gettextInterpolate(this.$pgettext('statuses', '%{courierI18n} in transit to destination'), {courierI18n: this.courierI18n}),
          'DELIVERED': this.$pgettext('statuses', 'Shipping delivered'),
          'INCIDENCE': this.$pgettext('statuses', 'On incidence'),
          'CANCELED': this.$pgettext('statuses', 'Canceled'),
          'TOBERETURNED': this.$pgettext('statuses', 'To be returned to sender'),
          'RETURNED': this.$pgettext('statuses', 'Returned to sender')
        },
        reverse: {
          'DRAFT': this.$pgettext('statuses', 'Created in the system'),
          'READYATSTORE': this.$pgettext('statuses', 'Ready at store'),
          'READY': this.$pgettext('statuses', 'Ready to be scheduled'),
          'WAITING': this.$gettextInterpolate(this.$pgettext('statuses', 'Searching for %{courierI18n}'), {courierI18n: this.courierI18n}),
          'PROGRAMMED': this.$pgettext('statuses', 'Route programmed'),
          'CONFIRMED': this.$gettextInterpolate(this.$pgettext('statuses', '%{courierI18n} in transit to origin'), {courierI18n: this.courierI18n}),
          'ATPICKUPPOINT': this.$gettextInterpolate(this.$pgettext('statuses', '%{courierI18n} arrived to origin'), {courierI18n: this.courierI18n}),
          'PICKEDUP': this.$pgettext('statuses', 'Shipping picked up on origin'),
          'INTRANSIT': this.$gettextInterpolate(this.$pgettext('statuses', '%{courierI18n} in transit to destination'), {courierI18n: this.courierI18n}),
          'DELIVERED': this.$pgettext('statuses', 'Shipping delivered'),
          'INCIDENCE': this.$pgettext('statuses', 'On incidence'),
          'CANCELED': this.$pgettext('statuses', 'Canceled'),
          'TOBERETURNED': this.$pgettext('statuses', 'To be returned to sender'),
          'RETURNED': this.$pgettext('statuses', 'Returned to sender')
        }
      }
    },
    statusReasonsStrings() {
      return {
        'error': this.$gettext('Taken by mistake'),
        'technical_issue': this.$gettext('Vehicle problem'),
        'absent_client': this.$gettext('Absent client'),
        'incorrect_address': this.$gettext('Wrong address'),
        'unavailable_product': this.$gettext('Unavailable product'),
        'unrecognized': this.$gettext('Shipping not accepted'),
        'wrong_size': this.$gettext('Wrong package size'),
        'rejected': this.$gettext('Shipping not expected')
      }
    },
    statusReasonEvents() {
      return {
        'CONFIRMED': this.$pgettext('reasonEvent', 'in transit to origin'),
        'PICKEDUP': this.$pgettext('reasonEvent', 'on origin'),
        'INTRANSIT': this.$pgettext('reasonEvent', 'in transit to destination'),
        'DELIVERED': this.$pgettext('reasonEvent', 'on destination'),
        'RETURNED': this.$pgettext('reasonEvent', 'on returning to sender')
      }
    }
  }
}
